import { OFFERID } from './lenders'

export const lendersInfo = {
  [OFFERID.MONEYME_PL]: {
    lender: 'moneymePl',
    name: 'MoneyMe',
    deskName: 'MoneyMe PL',
    zendeskTag: 'moneyme',
    logo: 'https://marketing-assets.driva.com.au/driva-email/moneyme.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 15,
    keyFeature: 'Fast approval process',
  },
  [OFFERID.LOAN_U]: {
    lender: 'LoanU',
    name: 'LoanU',
    deskName: 'LoanU',
    zendeskTag: 'LoanU',
    logo: 'https://marketing-assets.driva.com.au/driva-email/loanU.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 25,
    keyFeature: 'Fast approvals',
  },
  [OFFERID.LOAN_U_PL]: {
    lender: 'loanUPl',
    name: 'LoanU',
    deskName: 'LoanU PL',
    zendeskTag: 'LoanU',
    logo: 'https://marketing-assets.driva.com.au/driva-email/loanU.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 25,
    keyFeature: 'Fast approvals',
  },
  [OFFERID.BFS]: {
    lender: 'BFS',
    name: 'Branded Financial Services',
    deskName: 'BFS',
    zendeskTag: 'bfs',
    logo: 'https://marketing-assets.driva.com.au/driva-email/BFS.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 25,
    keyFeature: 'Great for new businesses',
  },
  [OFFERID.VOLKSWAGEN]: {
    lender: 'volkswagen',
    name: 'Volkswagen',
    deskName: 'Volkswagen',
    zendeskTag: null,
    logo: null,
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.AFS]: {
    lender: 'afs',
    name: 'Afs',
    deskName: 'Afs',
    zendeskTag: 'afs',
    logo: 'https://marketing-assets.driva.com.au/driva-email/AFS.jpg',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.AFS_VYRO]: {
    lender: 'afs',
    name: 'Afs',
    deskName: 'AfsVyro',
    zendeskTag: 'afs',
    logo: 'https://marketing-assets.driva.com.au/driva-email/AFS.jpg',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.ANGLE]: {
    lender: 'angle',
    name: 'Angle',
    deskName: 'Angle',
    zendeskTag: 'anglefinance',
    logo: 'https://marketing-assets.driva.com.au/driva-email/AngleFinance.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 150,
    keyFeature: 'Fast approvals',
  },
  [OFFERID.ANZ]: {
    lender: 'anz',
    name: 'ANZ',
    deskName: 'ANZ',
    zendeskTag: 'anz',
    logo: 'https://marketing-assets.driva.com.au/driva-email/ANZ.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 150,
    keyFeature: 'Well-recognised brand',
  },
  [OFFERID.FINANCE_ONE]: {
    lender: 'financeOne',
    name: 'Finance One',
    deskName: 'Finance One',
    zendeskTag: 'finance1',
    logo: 'https://marketing-assets.driva.com.au/driva-email/Finance1.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 150,
    keyFeature: 'Accept impaired credit',
  },
  [OFFERID.FINANCE_ONE_C]: {
    lender: 'financeOneC',
    name: 'Finance One',
    deskName: 'Finance One Commercial',
    zendeskTag: 'finance1',
    logo: 'https://marketing-assets.driva.com.au/driva-email/Finance1.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 150,
    keyFeature: 'Accept impaired credit',
  },
  [OFFERID.FINANCE_ONE_PL]: {
    lender: 'financeOnePl',
    name: 'Finance One',
    deskName: 'Finance One PL',
    zendeskTag: 'finance1',
    logo: 'https://marketing-assets.driva.com.au/driva-email/Finance1.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 150,
    keyFeature: 'Accept impaired credit',
  },
  [OFFERID.FIRST_MAC]: {
    lender: 'firstMac',
    name: 'Firstmac',
    deskName: 'Firstmac',
    zendeskTag: 'firstmac',
    logo: 'https://marketing-assets.driva.com.au/driva-email/firstmacLogo.png',
    terminationFees: true,
    terminationFeesAmount: '$700 in year 1, then $500 (None in final year',
    secure: true,
    defaultFee: 150,
    keyFeature: 'Great for first time borrowers',
  },
  [OFFERID.SHIFT_COMMERCIAL]: {
    lender: 'shiftCommercial',
    name: 'Shift Commercial',
    deskName: 'shiftCommercial',
    zendeskTag: 'shiftCommercial',
    logo: 'https://marketing-assets.driva.com.au/driva-email/shiftCommercial.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 25,
    keyFeature: 'Same day approvals',
  },
  [OFFERID.GROW]: {
    lender: 'grow',
    name: 'Grow',
    deskName: 'Grow',
    zendeskTag: 'grow',
    logo: 'https://marketing-assets.driva.com.au/driva-email/grow.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 25,
    keyFeature: 'Low doc options',
  },
  [OFFERID.GROW_CONSUMER]: {
    lender: 'growConsumer',
    name: 'Grow Consumer',
    deskName: 'Grow',
    zendeskTag: 'grow',
    logo: 'https://marketing-assets.driva.com.au/driva-email/grow.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 0,
    keyFeature: 'Low doc options',
  },
  [OFFERID.LATITUDE]: {
    lender: 'latitude',
    name: 'Latitude',
    deskName: 'Latitude',
    zendeskTag: 'latitude',
    logo: 'https://marketing-assets.driva.com.au/driva-email/latitudeLogo.png',
    terminationFees: true,
    terminationFeesAmount: '$750 (or 6.25% loan amount < $12,000) pro rata',
    secure: true,
    defaultFee: 25,
    keyFeature: 'Great for all vehicle types',
  },
  [OFFERID.LIBERTY]: {
    lender: 'liberty',
    name: 'Liberty',
    deskName: 'Liberty',
    zendeskTag: 'liberty',
    logo: 'https://marketing-assets.driva.com.au/driva-email/libertyLogo.png',
    terminationFees: true,
    terminationFeesAmount: '$270 flat fee plus variable amount',
    secure: true,
    defaultFee: 150,
    keyFeature: 'Accepts most income types',
  },
  [OFFERID.LIBERTY_C]: {
    lender: 'libertyC',
    name: 'Liberty',
    deskName: 'Liberty Commercial',
    zendeskTag: 'liberty',
    logo: 'https://marketing-assets.driva.com.au/driva-email/libertyLogo.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 150,
    keyFeature: 'Accepts most income types',
  },
  [OFFERID.MACQUARIE]: {
    lender: 'macquarie',
    name: 'Macquarie',
    deskName: 'Macquarie',
    zendeskTag: 'macquarie',
    logo: 'https://marketing-assets.driva.com.au/driva-email/macquarieLogo.png',
    terminationFees: true,
    terminationFeesAmount: '$150 flat fee plus $650 pro-rata',
    secure: true,
    defaultFee: 150,
    keyFeature: 'Low rates (but higher fees)',
  },
  [OFFERID.MACQUARIE_C]: {
    lender: 'macquarieC',
    name: 'Macquarie',
    deskName: 'Macquarie Commercial',
    zendeskTag: 'macquarie',
    logo: 'https://marketing-assets.driva.com.au/driva-email/macquarieLogo.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 150,
    keyFeature: 'Low rates (but higher fees)',
  },
  [OFFERID.METRO]: {
    lender: 'metro',
    name: 'Metro',
    deskName: 'Metro',
    zendeskTag: 'metro',
    logo: 'https://marketing-assets.driva.com.au/driva-email/Metrofinance.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 150,
    keyFeature: 'Great for established borrowers',
  },
  [OFFERID.MONEY_THREE]: {
    lender: 'moneyThree',
    name: 'Money3',
    deskName: 'Money3',
    zendeskTag: 'money3',
    logo: 'https://marketing-assets.driva.com.au/driva-email/moneyThree.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 25,
    keyFeature: 'Accept impaired credit',
  },
  [OFFERID.MONEY_THREE_PL]: {
    lender: 'moneyThreePl',
    name: 'Money3',
    deskName: 'Money3 PL',
    zendeskTag: 'money3',
    logo: 'https://marketing-assets.driva.com.au/driva-email/moneyThree.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 25,
    keyFeature: 'Accept impaired credit',
  },
  [OFFERID.MONEY_PLACE]: {
    lender: 'moneyPlace',
    name: 'MoneyPlace',
    deskName: 'MoneyPlace',
    zendeskTag: 'moneyplace',
    logo: 'https://marketing-assets.driva.com.au/quotes-email/moneyplace-logo.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: 'Fast, digital application process',
  },
  [OFFERID.MONEY_PLACE_PL]: {
    lender: 'moneyPlacePl',
    name: 'MoneyPlace',
    deskName: 'MoneyPlace PL',
    zendeskTag: 'moneyplace',
    logo: 'https://marketing-assets.driva.com.au/quotes-email/moneyplace-logo.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 0,
    keyFeature: 'Fast, digital application process',
  },
  [OFFERID.NOW_FINANCE]: {
    lender: 'nowFinance',
    name: 'NOW Finance',
    deskName: 'NOW Finance',
    zendeskTag: 'now_finance',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/nowfinance.jpeg',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.NOW_FINANCE_PL]: {
    lender: 'nowFinancePl',
    name: 'NOW Finance',
    deskName: 'NOW Finance PL',
    zendeskTag: 'nowFinancePl',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/nowfinance.jpeg',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.NOW_FINANCE_RO_PL]: {
    lender: 'nowFinanceRoPl',
    name: 'NOW Finance',
    deskName: 'NOW Finance RO PL',
    zendeskTag: 'nowFinanceRoPl',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/nowfinance.jpeg',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.PEPPER]: {
    lender: 'pepper',
    name: 'Pepper',
    deskName: 'Pepper',
    zendeskTag: 'pepper',
    logo: 'https://marketing-assets.driva.com.au/driva-email/pepperLogo.png',
    terminationFees: true,
    terminationFeesAmount: '$700 pro-rata (None in final year)',
    secure: true,
    defaultFee: 25,
    keyFeature: 'Great for older vehicles',
  },
  [OFFERID.PEPPER_C]: {
    lender: 'pepperC',
    name: 'Pepper',
    deskName: 'Pepper Commercial',
    zendeskTag: 'pepper',
    logo: 'https://marketing-assets.driva.com.au/driva-email/pepperLogo.png',
    terminationFees: true,
    terminationFeesAmount: '30% of unpaid interest',
    secure: true,
    defaultFee: 25,
    keyFeature: 'Great for older vehicles',
  },
  [OFFERID.PROSPA]: {
    lender: 'prospa',
    name: 'Prospa',
    deskName: 'Prospa',
    zendeskTag: null,
    logo: null,
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.RATE_SETTER]: {
    lender: 'rateSetter',
    name: 'Plenti',
    deskName: 'Plenti',
    zendeskTag: 'plenti',
    logo: 'https://marketing-assets.driva.com.au/driva-email/plentiLogo.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 15,
    keyFeature: 'Fast approvals',
  },
  [OFFERID.RATE_SETTER_PL]: {
    lender: 'rateSetterPl',
    name: 'Plenti',
    deskName: 'Plenti PL',
    zendeskTag: 'plenti',
    logo: 'https://marketing-assets.driva.com.au/driva-email/plentiLogo.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 15,
    keyFeature: 'Fast approvals',
  },
  [OFFERID.PLENTI_C]: {
    lender: 'plentiC',
    name: 'Plenti',
    deskName: 'Plenti Commercial',
    zendeskTag: 'plenti',
    logo: 'https://marketing-assets.driva.com.au/driva-email/plentiLogo.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 15,
    keyFeature: 'Fast approvals',
  },
  [OFFERID.SOCIETY_ONE]: {
    lender: 'societyOne',
    name: 'SocietyOne',
    deskName: 'SocietyOne',
    zendeskTag: 'society_one',
    logo: null,
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.ST_GEORGE]: {
    lender: 'stGeorge',
    name: 'St.George',
    deskName: 'St.George',
    zendeskTag: null,
    logo: null,
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.WESTPAC]: {
    lender: 'westpac',
    name: 'Westpac',
    deskName: 'Westpac',
    zendeskTag: null,
    logo: null,
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.WISR]: {
    lender: 'wisr',
    name: 'Wisr',
    deskName: 'Wisr',
    zendeskTag: 'wisr',
    logo: 'https://marketing-assets.driva.com.au/driva-email/wisrLogo.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 25,
    keyFeature: 'Accepts joint applicants',
  },
  [OFFERID.WISR_PL]: {
    lender: 'wisrPl',
    name: 'Wisr',
    deskName: 'Wisr PL',
    zendeskTag: 'wisr',
    logo: 'https://marketing-assets.driva.com.au/driva-email/wisrLogo.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 25,
    keyFeature: 'Accepts joint applicants',
  },
  [OFFERID.AUTOPAY]: {
    lender: 'Autopay',
    name: 'Autopay',
    deskName: 'Autopay',
    zendeskTag: 'autopay',
    logo: 'https://marketing-assets.driva.com.au/driva-email/autopay.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: 'Fast approvals and settlements',
  },
  [OFFERID.AUTOPAY_C]: {
    lender: 'AutopayC',
    name: 'Autopay',
    deskName: 'Autopay Commercial',
    zendeskTag: 'autopay',
    logo: 'https://marketing-assets.driva.com.au/driva-email/autopay.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: 'Fast approvals and settlements',
  },
  [OFFERID.GREEN_LIGHT_AUTO]: {
    lender: 'GreenLightAuto',
    name: 'Green Light Auto',
    deskName: 'Green Light Auto',
    zendeskTag: 'greenlightauto',
    logo: 'https://marketing-assets.driva.com.au/driva-email/greenlightauto.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: 'Fast and easy to apply',
  },
  [OFFERID.CAR_START]: {
    lender: 'CarStart',
    name: 'Car Start',
    deskName: 'Car Start',
    zendeskTag: 'carstart',
    logo: 'https://marketing-assets.driva.com.au/driva-email/carstart.jpg',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: 'Speedy car finance',
  },
  [OFFERID.MEDFIN]: {
    lender: 'Medfin',
    name: 'Medfin',
    deskName: 'Medfin',
    zendeskTag: 'medfin',
    logo: 'https://marketing-assets.driva.com.au/driva-email/medfin.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: 'Streamlined process makes vehicle financing simple',
  },
  [OFFERID.AMMF]: {
    lender: 'AMMF',
    name: 'AMMF',
    deskName: 'AMMF',
    zendeskTag: 'ammf',
    logo: 'https://marketing-assets.driva.com.au/driva-email/ammf.jpeg',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: 'Simple and convenient',
  },
  [OFFERID.LATITUDE_PL]: {
    lender: 'latitudePl',
    name: 'Latitude',
    deskName: 'Latitude PL',
    zendeskTag: 'latitude',
    logo: 'https://marketing-assets.driva.com.au/driva-email/latitudeLogo.png',
    terminationFees: true,
    terminationFeesAmount: '$750 (or 6.25% loan amount < $12,000) pro rata',
    secure: false,
    defaultFee: 25,
    keyFeature: 'Great for all vehicle types',
  },
  [OFFERID.OUR_MONEY_MARKET_PL]: {
    lender: 'ourMoneyMarketPl',
    name: 'Our Money Market',
    deskName: 'Our Money Market PL',
    zendeskTag: 'ourMoneyMarket',
    logo: 'https://marketing-assets.driva.com.au/driva-email/omm.png',
    terminationFees: true,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 25,
    keyFeature: 'Simple and convenient',
  },
  [OFFERID.OUR_MONEY_MARKET_RO_PL]: {
    lender: 'ourMoneyMarketRoPl',
    name: 'Our Money Market',
    deskName: 'Our Money Market RO PL',
    zendeskTag: 'ourMoneyMarketRoPl',
    logo: 'https://marketing-assets.driva.com.au/driva-email/omm.png',
    terminationFees: true,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 0,
    keyFeature: 'Simple and convenient',
  },
  [OFFERID.OUR_MONEY_MARKET_SECURED]: {
    lender: 'ourMoneyMarketSecured',
    name: 'Our Money Market',
    deskName: 'Our Money Market',
    zendeskTag: 'ourMoneyMarketSecured',
    logo: 'https://marketing-assets.driva.com.au/driva-email/ommsecured.png',
    terminationFees: true,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 25,
    keyFeature: 'Simple and convenient',
  },
  [OFFERID.AFFORDABLE_CAR_LOANS]: {
    lender: 'affordableCarLoans',
    name: 'Affordable Car Loans',
    deskName: 'Affordable Car Loans',
    zendeskTag: 'affordableCarLoans',
    logo: 'https://marketing-assets.driva.com.au/driva-email/AffordableCarLoans.jpg',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 25,
    keyFeature: 'Fast approvals, accept credit impaired',
  },
  [OFFERID.ALEX_BANK]: {
    lender: 'alexBank',
    name: 'Alex Bank',
    deskName: 'Alex Bank',
    zendeskTag: 'alexBank',
    logo: 'https://marketing-assets.driva.com.au/driva-email/alexBanking.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 0,
    keyFeature: 'Fast and flexible',
  },
  [OFFERID.ALEX_BANK_SECURED]: {
    lender: 'alexBankSecured',
    name: 'Alex Bank',
    deskName: 'Alex Bank',
    zendeskTag: 'alexBankSecured',
    logo: 'https://marketing-assets.driva.com.au/driva-email/alexBanking.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 0,
    keyFeature: 'Fast and flexible',
  },
  [OFFERID.FINANCE_ONE_PLATINUM]: {
    lender: 'financeOnePlatinum',
    name: 'Finance One Platinum',
    deskName: 'Finance One Platinum',
    zendeskTag: 'financeOnePlatinum',
    logo: 'https://marketing-assets.driva.com.au/driva-email/Finance1.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: false,
    defaultFee: 150,
    keyFeature: 'Accept impaired credit',
  },
  [OFFERID.FAIR_GO_FINANCE]: {
    lender: 'fairGoFinance',
    name: 'Fair Go Finance',
    deskName: 'Fair Go Finance',
    zendeskTag: 'fairGoFinance',
    logo: 'https://marketing-assets.driva.com.au/driva-email/fairgofinance.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 150,
    keyFeature: 'Great for credit impaired customers',
  },
  [OFFERID.SALT_AND_LIME]: {
    lender: 'saltAndLime',
    name: 'Salt & Lime',
    deskName: 'Salt & Lime',
    zendeskTag: 'saltAndLime',
    logo: 'https://marketing-assets.driva.com.au/driva-email/saltAndLime.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 150,
    keyFeature: 'Great for credit impaired customers',
  },
  [OFFERID.METRO_CONSUMER]: {
    lender: 'metro',
    name: 'Metro',
    deskName: 'metroConsumer',
    zendeskTag: 'metroConsumer',
    logo: 'https://marketing-assets.driva.com.au/driva-email/Metrofinance.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 150,
    keyFeature: 'Great for established borrowers',
  },
  [OFFERID.SALT_AND_LIME_SECURED]: {
    lender: 'saltAndLimeSecured',
    name: 'Salt & Lime',
    deskName: 'Salt & Lime Secured',
    zendeskTag: 'saltAndLimeSecured',
    logo: 'https://marketing-assets.driva.com.au/driva-email/saltAndLime.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 150,
    keyFeature: 'Great for credit impaired customers',
  },
  [OFFERID.RAPID_LOANS_PL]: {
    lender: 'rapidLoansPl',
    name: 'Rapid Loans',
    deskName: 'Rapid Loans Pl',
    zendeskTag: 'rapidLoansPl',
    logo: 'https://marketing-assets.driva.com.au/driva-email/rapidLoans.jpg',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 150,
    keyFeature: 'Great for credit impaired customers',
  },
  [OFFERID.JACARANDA_PL]: {
    lender: 'jacarandaPL',
    name: 'Jacaranda',
    deskName: 'Jacaranda Pl',
    zendeskTag: 'jacarandaPL',
    logo: 'https://marketing-assets.driva.com.au/driva-email/jacaranda.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 35,
    keyFeature: 'Fast approvals',
  },
  [OFFERID.RAPID_LOANS]: {
    lender: 'rapidLoans',
    name: 'Rapid Loans',
    deskName: 'Rapid Loans',
    zendeskTag: 'rapidLoans',
    logo: 'https://marketing-assets.driva.com.au/driva-email/rapidLoans.jpg',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 150,
    keyFeature: 'Great for credit impaired customers',
  },
  [OFFERID.CREDIT24_PL]: {
    lender: 'credit24Pl',
    name: 'Credit24',
    deskName: 'credit24 Pl',
    zendeskTag: 'credit24Pl',
    logo: 'https://marketing-assets.driva.com.au/driva-email/credit24.jpg',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 25,
    keyFeature: 'Great for credit impaired customers',
  },
  [OFFERID.METRO_NOVATED]: {
    lender: 'metroNovated',
    name: 'Metro',
    deskName: 'metroNovated',
    zendeskTag: 'metroNovated',
    logo: 'https://marketing-assets.driva.com.au/driva-email/Metrofinance.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 150,
    keyFeature: 'Great for established borrowers',
  },
  [OFFERID.AVANTI_FINANCE_PL]: {
    lender: 'Avanti Finance PL',
    name: 'Avanti Finance',
    deskName: 'avantiFinancePl',
    zendeskTag: 'avantiFinancePl',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/avantifinance.png',
    terminationFees: true,
    terminationFeesAmount: '$28',
    secure: false,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.HEARTLAND_BANK]: {
    lender: 'heartlandBank',
    name: 'Heartland Bank',
    deskName: 'heartlandBank',
    zendeskTag: 'heartlandBank',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/heartlandbank.png',
    terminationFees: true,
    terminationFeesAmount: '$7 fee',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.UDC_FINANCE]: {
    lender: 'udcFinance',
    name: 'UDC Finance',
    deskName: 'udcFinance',
    zendeskTag: 'udcFinance',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/udc.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.GEM_BY_LATITUDE]: {
    lender: 'gemByLatitude',
    name: 'Gem by Latitude',
    deskName: 'gemByLatitude',
    zendeskTag: 'gemByLatitude',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/gem.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.FINANCE_NOW]: {
    lender: 'financeNow',
    name: 'Finance Now',
    deskName: 'financeNow',
    zendeskTag: 'financeNow',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/financenow.png',
    terminationFees: true,
    terminationFeesAmount: 'Loss of interest cost',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.FINANCE_NOW_PL]: {
    lender: 'financeNowPl',
    name: 'Finance Now PL',
    deskName: 'financeNowPl',
    zendeskTag: 'financeNowPl',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/financenow.png',
    terminationFees: true,
    terminationFeesAmount: 'Loss of interest cost',
    secure: false,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.AZORA_COMMERCIAL]: {
    lender: 'azoraCommercial',
    name: 'Azora Commercial',
    deskName: 'azoraCommercial',
    zendeskTag: 'azora',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/azoraLogo.png',
    terminationFees: true,
    terminationFeesAmount: 'TBA',
    secure: true,
    defaultFee: 0,
    keyFeature: 'Best for older assets',
  },
  [OFFERID.RESIMAC_COMMERCIAL]: {
    lender: 'resimacCommercial',
    name: 'Resimac Commercial',
    deskName: 'resimacCommercial',
    zendeskTag: 'resimac',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/resimac.png',
    terminationFees: true,
    terminationFeesAmount: 'No early exit fee and 2% discount on remaining interest',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.PLENTI_RO_PL_FIXED]: {
    lender: 'plentiRoPlFixed',
    name: 'Plenti',
    deskName: 'Plenti RO PL Fixed',
    zendeskTag: 'plentiRoPlFixed',
    logo: 'https://jump-marketing-assets.s3-ap-southeast-2.amazonaws.com/driva-email/plentiLogo.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.LATITUDE_RO_PL]: {
    lender: 'latitudeRoPl',
    name: 'Latitude',
    deskName: 'Latitude RO PL',
    zendeskTag: 'latitudeRoPl',
    logo: null,
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.FAIR_GO_FINANCE_RO_PL]: {
    lender: 'FairGoFinanceRoPl',
    name: 'Fair Go Finance',
    deskName: 'Fair Go Finance RO PL',
    zendeskTag: 'fairGoFinanceRoPl',
    logo: 'https://marketing-assets.driva.com.au/driva-email/fairgofinance.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 150,
    keyFeature: 'Great for credit impaired customers',
  },

  [OFFERID.CFS]: {
    lender: 'CFS Consumer',
    name: 'CFS',
    deskName: 'CFS',
    zendeskTag: 'cfsconsumer',
    logo: 'https://marketing-assets.driva.com.au/driva-email/cfslogo.png',
    terminationFees: true,
    terminationFeesAmount: '$125',
    secure: true,
    defaultFee: 0,
    keyFeature: '',
  },

  [OFFERID.GENEVA_FINANCE]: {
    lender: 'Geneva Finance Consumer',
    name: 'Geneva Finance',
    deskName: 'Geneva Finance',
    zendeskTag: 'genevafinanceconsumer',
    logo: 'https://marketing-assets.driva.com.au/driva-email/genevafinancelogo.png',
    terminationFees: true,
    terminationFeesAmount: 'Depends based on time loan paid off',
    secure: true,
    defaultFee: 0,
    keyFeature: '',
  },
  [OFFERID.GENEVA_FINANCE_PL]: {
    lender: 'Geneva Finance PL',
    name: 'Geneva Finance',
    deskName: 'Geneva Finance PL',
    zendeskTag: 'genevafinancepl',
    logo: 'https://marketing-assets.driva.com.au/driva-email/genevafinancelogo.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable',
    secure: false,
    defaultFee: 0,
    keyFeature: '',
  },

  [OFFERID.AVANTI_FINANCE]: {
    lender: 'Avanti Finance Consumer',
    name: 'Avanti Finance',
    deskName: 'Avanti Finance',
    zendeskTag: 'avantiFinanceConsumer',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/avantifinance.png',
    terminationFees: true,
    terminationFeesAmount: '$60',
    secure: true,
    defaultFee: 0,
    keyFeature: '',
  },

  [OFFERID.FHL]: {
    lender: 'FHL Consumer',
    name: 'FHL',
    deskName: 'FHL',
    zendeskTag: 'fhlconsumer',
    logo: 'https://marketing-assets.driva.com.au/driva-email/FHLLogo.png',
    terminationFees: true,
    terminationFeesAmount: '$45',
    secure: true,
    defaultFee: 0,
    keyFeature: '',
  },

  [OFFERID.FHL_COMMERCIAL]: {
    lender: 'FHL Commercial',
    name: 'FHL Commercial',
    deskName: 'FHL Commercial',
    zendeskTag: 'fhlcommercial',
    logo: 'https://marketing-assets.driva.com.au/driva-email/FHLLogo.png',
    terminationFees: true,
    terminationFeesAmount: '$45',
    secure: true,
    defaultFee: 0,
    keyFeature: '',
  },

  [OFFERID.FHL_PL]: {
    lender: 'FHL PL',
    name: 'FHL PL',
    deskName: 'FHL PL',
    zendeskTag: 'fhlPl',
    logo: 'https://marketing-assets.driva.com.au/driva-email/FHLLogo.png',
    terminationFees: true,
    terminationFeesAmount: '$45',
    secure: true,
    defaultFee: 0,
    keyFeature: '',
  },

  [OFFERID.UDC_FINANCE_COMMERCIAL]: {
    lender: 'UDC Finance Commercial',
    name: 'UDC Finance Commercial',
    deskName: 'UDC Finance Commercial',
    zendeskTag: 'udccommercial',
    logo: 'https://marketing-assets.driva.com.au/driva-email/udc.png',
    terminationFees: true,
    terminationFeesAmount: '$500 settlement fee + break cost fee',
    secure: true,
    defaultFee: 0,
    keyFeature: '',
  },

  [OFFERID.AVANTI_FINANCE_COMMERCIAL]: {
    lender: 'Avanti Finance Commercial',
    name: 'Avanti Finance Commercial',
    deskName: 'Avanti Finance Commercial',
    zendeskTag: 'avantiFinanceCommercial',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/avantifinance.png',
    terminationFees: true,
    terminationFeesAmount: '$60 fee',
    secure: true,
    defaultFee: 0,
    keyFeature: '',
  },

  [OFFERID.HEARTLAND_BANK_COMMERCIAL]: {
    lender: 'heartlandBankCommercial',
    name: 'Heartland Commercial',
    deskName: 'heartlandBankCommercial',
    zendeskTag: 'heartlandBankCommercial',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/heartlandbank.png',
    terminationFees: true,
    terminationFeesAmount: '$7 fee',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },

  [OFFERID.LUMI_COMMERCIAL]: {
    lender: 'Lumi Commercial',
    name: 'Lumi',
    deskName: 'Lumi Commercial',
    zendeskTag: 'lumiCommercial',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/LumiCommercialLogo.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 0,
    keyFeature: '',
  },

  [OFFERID.FINANCE_ONE_PLUS]: {
    lender: 'Finance One Plus',
    name: 'Finance One',
    deskName: 'Finance One Plus',
    zendeskTag: 'finance1Plus',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/LumiCommercialLogo.png',
    terminationFees: true,
    terminationFeesAmount: '$995 pro-rata after 12months',
    secure: true,
    defaultFee: 0,
    keyFeature: '',
  },

  [OFFERID.MTF_FINANCE]: {
    lender: 'MTF Finance',
    name: 'MTF',
    deskName: 'MTF Finance',
    zendeskTag: 'mtfFinance',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/MTFLogo.png',
    terminationFees: true,
    terminationFeesAmount: '$24.50 fee',
    secure: true,
    defaultFee: 0,
    keyFeature: '',
  },

  [OFFERID.OXFORD_FINANCE]: {
    lender: 'Oxford Finance',
    name: 'Oxford',
    deskName: 'Oxford Finance',
    zendeskTag: 'oxfordFinance',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/OxfordFinanceLogo.png',
    terminationFees: true,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: '',
  },

  [OFFERID.HEARTLAND_PL]: {
    lender: 'Heartland PL',
    name: 'Heartland PL',
    deskName: 'Heartland PL',
    zendeskTag: 'heartlandPl',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/heartlandbank.png',
    terminationFees: true,
    terminationFeesAmount: '$7 fee',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },

  [OFFERID.TRUEPILLARS_COMMERCIAL]: {
    lender: 'Truepillars Commercial',
    name: 'Truepillars Commercial',
    deskName: 'Truepillars Commercial',
    zendeskTag: 'truepillarsCommercial',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/TruepillarsLogo.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },

  [OFFERID.FINANCE_ONE_PLUS_COMMERCIAL]: {
    lender: 'Finance One Plus Commercial',
    name: 'Finance One Plus Commercial',
    deskName: 'Finance One Plus Commercial',
    zendeskTag: 'finance1PlusCommercial',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/FinanceOnePlusLogo.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },

  [OFFERID.SELFCO_COMMERCIAL]: {
    lender: 'Selfco Commercial',
    name: 'Selfco Commercial',
    deskName: 'Selfco Commercial',
    zendeskTag: 'selfcoCommercial',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/SelfcoLogo.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },

  [OFFERID.ANGLE_NOVATED]: {
    lender: 'Angle Novated',
    name: 'Angle',
    deskName: 'angleNovated',
    zendeskTag: 'angleNovated',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/AngleNovated.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 150,
    keyFeature: 'Great for established borrowers',
  },

  [OFFERID.REVOLUT_RO_PL]: {
    lender: 'Revolut PL',
    name: 'Revolut',
    deskName: 'Revolut PL',
    zendeskTag: 'revolutRoPl',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/revolut.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 0,
    keyFeature: null,
  },

  [OFFERID.PLENTI_RO_PL_VARIABLE]: {
    lender: 'plentiRoPlVariable',
    name: 'Plenti',
    deskName: 'Plenti RO PL Variable',
    zendeskTag: 'plentiRoPlVariable',
    logo: 'https://jump-marketing-assets.s3-ap-southeast-2.amazonaws.com/driva-email/plentiLogo.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },

  [OFFERID.WISR_RO_PL]: {
    lender: 'Wisr RO PL',
    name: 'Wisr',
    deskName: 'Wisr RO PL',
    zendeskTag: 'wisrRoPl',
    logo: 'https://marketing-assets.driva.com.au/driva-email/wisrLogo.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 0,
    keyFeature: 'Accepts joint applicants',
  },

  [OFFERID.DRIVA_NOVATED]: {
    lender: 'Driva Novated',
    name: 'Driva',
    deskName: 'Driva Novated',
    zendeskTag: 'drivaNovated',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/DrivaLogo.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 150,
    keyFeature: 'Great for established borrowers',
  },

  [OFFERID.MONEYME_PL_PAYSLIP_ONLY]: {
    lender: 'MoneyMe PL Payslip Only',
    name: 'MoneyMe PL',
    deskName: 'MoneyMe PL Payslip Only',
    zendeskTag: 'moneyMePlPayslipOnly',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/moneyme.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 0,
    keyFeature: null,
  },

  [OFFERID.LIBERTY_NOVATED]: {
    lender: 'Liberty Novated',
    name: 'Liberty Novated',
    deskName: 'Liberty Novated',
    zendeskTag: 'libertyNovated',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/LibertyNovatedLogo.png',
    terminationFees: true,
    terminationFeesAmount: 'Portion of the interest payable',
    secure: true,
    defaultFee: 0,
    keyFeature: 'Approvals for non-conforming/credit impaired applicants seeking a novated lease',
  },

  [OFFERID.THE_ASSET_FINANCIER_CONSUMER]: {
    lender: 'The Asset Financier (Allied)',
    name: 'The Asset Financier (Allied)',
    deskName: 'The Asset Financier (Allied)',
    zendeskTag: 'theAssetFinancierConsumer',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/AlliedLogo.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 0,
    keyFeature: 'Unique credit matrix that looks at Negative score, Dealer only sales',
  },

  [OFFERID.THE_ASSET_FINANCIER_COMMERCIAL]: {
    lender: 'The Asset Financier (Allied) Commercial',
    name: 'The Asset Financier (Allied) Commercial',
    deskName: 'The Asset Financier (Allied) Commercial',
    zendeskTag: 'theAssetFinancierCommercial',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/AlliedLogo.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 0,
    keyFeature: 'Unique credit matrix that looks at Negative score, Dealer only sales',
  },

  [OFFERID.MONEYME_RO_PL]: {
    lender: 'MoneyMe RO PL',
    name: 'MoneyMe',
    deskName: 'MoneyMe RO PL',
    zendeskTag: 'moneyMeRoPl',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/moneyMeLogoNew.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 0,
    keyFeature: null,
  },

  [OFFERID.DYNA_MONEY]: {
    lender: 'DynaMoney Commercial',
    name: 'DYNAMONEY LIMITED',
    deskName: 'DynaMoney Commercial',
    zendeskTag: 'dynaMoney',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/dynamoney.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 0,
    keyFeature: 'Approvals for greater aged vehicles and higher loan amounts for specific criteria.',
  },

  [OFFERID.ALLIED_NOVATED]: {
    lender: 'Allied Novated',
    name: 'Allied Retail Finance Pty Ltd',
    deskName: 'alliedNovated',
    zendeskTag: 'alliedNovated',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/alliedcredit.png',
    terminationFees: true,
    terminationFeesAmount: 'Variable based on time paid out',
    secure: true,
    defaultFee: 0,
    keyFeature: 'Sharp interest rates',
  },

  [OFFERID.ANGLE_AUTO]: {
    lender: 'Angle Auto',
    name: 'Angle Auto',
    deskName: 'Angle Auto',
    zendeskTag: 'angleAuto',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/AngleAutoLogo.png',
    terminationFees: true,
    terminationFeesAmount: '$750 fee',
    secure: true,
    defaultFee: 0,
    keyFeature: 'No minimum employment tenure (long-term continuity required)',
  },

  [OFFERID.OXFORD_COMMERCIAL]: {
    lender: 'Oxford Commercial',
    name: 'Oxford Commercial',
    deskName: 'Oxford Commercial',
    zendeskTag: 'oxfordCommercial',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/OxfordFinanceLogo.png',
    terminationFees: true,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },
  [OFFERID.MORRIS_FINANCE_COMMERCIAL]: {
    lender: 'Morris Finance',
    name: 'Morris Finance Commercial',
    deskName: 'Morris Finance Commercial',
    zendeskTag: 'morrisFinanceCommercial',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/morrisFinanceLogo.png',
    terminationFees: true,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: null,
  },

  [OFFERID.BIZCAP_COMMERCIAL]: {
    lender: 'Bizcap Commercial',
    name: 'Bizcap Commercial',
    deskName: 'Bizcap Commercial',
    zendeskTag: 'bizcapCommercial',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/bizcapLogo.png',
    terminationFees: true,
    terminationFeesAmount: 'Yes',
    secure: false,
    defaultFee: 0,
    keyFeature:
      'Business Term loans of $5k to $5mil, Line of Credit up to $750K, No upfront credit checks, no minimum credit score , Businesses with past judgments and defaults accepted',
  },

  [OFFERID.OXFORD_PL]: {
    lender: 'Oxford PL',
    name: 'Oxford PL',
    deskName: 'Oxford PL',
    zendeskTag: 'oxfordPl',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/OxfordFinanceLogo.png',
    terminationFees: true,
    terminationFeesAmount: 'Yes',
    secure: true,
    defaultFee: 0,
    keyFeature: 'Fast turnaround times and competitive rates for prime profiles.',
  },

  [OFFERID.GAMMA_DUO]: {
    lender: 'Gamma Duo',
    name: 'Gamma Duo',
    deskName: 'Gamma Duo',
    zendeskTag: 'gammaDuo',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/GammaDuoLogo.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature:
      'No minimum credit score, adverse profiles accepted, credit File Enquiry on Illion report only, competitive establishment/risk fees and no clawbacks and ETF',
  },

  [OFFERID.GAMMA_DUO_PL]: {
    lender: 'Gamma Duo PL',
    name: 'Gamma Duo PL',
    deskName: 'Gamma Duo PL',
    zendeskTag: 'gammaDuoPl',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/GammaDuoLogo.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 0,
    keyFeature:
      'No minimum credit score, adverse profiles accepted, credit File Enquiry on Illion report only, competitive establishment/risk fees and no clawbacks and ETF',
  },

  [OFFERID.JACARANDA_RO_PL]: {
    lender: 'Jacaranda RO PL',
    name: 'Jacaranda RO PL',
    deskName: 'Jacaranda RO PL',
    zendeskTag: 'jacarandaRoPl',
    logo: 'https://jump-marketing-assets.s3.ap-southeast-2.amazonaws.com/driva-email/jacaranda.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 35,
    keyFeature: 'Fast approvals',
  },

  [OFFERID.ALEX_BANK_RO]: {
    lender: 'Alex Bank RO',
    name: 'Alex Bank RO',
    deskName: 'Alex Bank RO',
    zendeskTag: 'alexBankRo',
    logo: 'https://marketing-assets.driva.com.au/driva-email/alexBanking.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: 'Fast and flexible',
  },

  [OFFERID.ALEX_BANK_RO_PL]: {
    lender: 'Alex Bank RO',
    name: 'Alex Bank RO',
    deskName: 'Alex Bank RO',
    zendeskTag: 'alexBankRo',
    logo: 'https://marketing-assets.driva.com.au/driva-email/alexBanking.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: false,
    defaultFee: 0,
    keyFeature: 'Fast and flexible',
  },

  [OFFERID.AUTO_FINANCE_DIRECT]: {
    lender: 'Auto Finance Direct',
    name: 'Auto Finance Direct',
    deskName: 'Auto Finance Direct',
    zendeskTag: 'autoFinanceDirect',
    logo: 'https://marketing-assets.driva.com.au/driva-email/autoFinanceDirect.png',
    terminationFees: true,
    terminationFeesAmount: '35$ Fee',
    secure: true,
    defaultFee: 0,
    keyFeature: 'Fast and flexible',
  },

  [OFFERID.HARMONEY]: {
    lender: 'Harmoney',
    name: 'Harmoney',
    deskName: 'Harmoney',
    zendeskTag: 'harmoney',
    logo: 'https://marketing-assets.driva.com.au/driva-email/harmoney.png',
    terminationFees: false,
    terminationFeesAmount: 'None',
    secure: true,
    defaultFee: 0,
    keyFeature: 'Fast approvals',
  },

  [OFFERID.LIBERTY_GFV]: {
    lender: 'Liberty GFV',
    name: 'Liberty GFV',
    deskName: 'Liberty GFV',
    zendeskTag: 'libertyGfv',
    logo: 'https://marketing-assets.driva.com.au/driva-email/libertyLogo.png',
    terminationFees: true,
    terminationFeesAmount: 'Limited to the principal owing + 1 monthly repayment ',
    secure: true,
    defaultFee: 10,
    keyFeature: 'Accepts most income types',
  },

  [OFFERID.LIBERTY_COMMERCIAL_GFV]: {
    lender: 'Liberty Commercial GFV',
    name: 'Liberty Commercial GFV',
    deskName: 'Liberty Commercial GFV',
    zendeskTag: 'libertyCommercialGfv',
    logo: 'https://marketing-assets.driva.com.au/driva-email/libertyLogo.png',
    terminationFees: true,
    terminationFeesAmount: 'Limited to the principal owing + 1 monthly repayment ',
    secure: true,
    defaultFee: 10,
    keyFeature: 'Accepts most income types',
  },
}
